import styles from './index.module.scss';
import EfImg from '@elem/ui/ef-img';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
// import { createPortal } from 'react-dom';
// import Modal2 from './Modal2';

type ImgItemType = {
    img: string;
    text: string;
};

export default function TheComp() {
    const { t } = useLang('dp3.page_v2');
    const [itemsEnter, setItemsEnter] = useState<boolean>(false);
    // const [btnEnter, setBtnEnter] = useState<boolean>(false);
    const [textEnter, setTextEnter] = useState<boolean>(false);
    // const [isOpen, setIsOpen] = useState<boolean>(false);

    const box4Items: ImgItemType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1745894043025/APP2.png',
            text: t('K2_box4_text1') || 'Energize Every Moment That Needs Electricity',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1745827332241/app.png',
            text: t('K2_box4_text2') || 'Dedicated NEMA TT-30R port makes powering your RV simple and reliable—anytime, anywhere.',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735640835063/C_4C.png',
            text: t('K2_box4_text3') || 'Easily supply power to off-grid cabins, ensuring comfortable off-grid experiences without interruption.',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1745894042723/APP3.png',
            text: t('K2_box4_text4') || 'Handle power-intensive tools with ease, delivering reliable energy to support all your on-site tasks and projects.',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1735640917200/C_4E.png',
            text: t('K2_box4_text5') || 'Enjoy silent, smokeless, and oil-free energy wherever your adventures take you, leaving nature undisturbed.',
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const textScene = AniContainer.create({
                triggerElement: '#dp3-K2 .info',
                triggerHook: 1,
                offset: 120,
                duration: '350%',
                onEnter: () => setTextEnter(true),
                onLeave: () => setTextEnter(false),
            });
            if (window?.innerWidth > 1024) {
                const scene1 = AniContainer.create({
                    triggerElement: '.OASIS-B',
                    triggerHook: 1,
                    offset: '120%',
                    duration: '200%',
                    onEnter: () => setItemsEnter(true),
                    onLeave: () => setItemsEnter(false),
                });
                // const scene2 = AniContainer.create({
                //     triggerElement: '.OASIS-B',
                //     triggerHook: 1,
                //     offset: '180%',
                //     duration: '220%',
                //     onEnter: () => setBtnEnter(true),
                //     onLeave: () => setBtnEnter(false),
                // });
                return () => {
                    scene1.destroy();
                    textScene.destroy();
                    // scene2.destory();
                };
            } else {
                const winH = window.innerHeight;
                const winW = window.innerWidth;
                const box4Lists: HTMLUListElement | null = document.querySelector('.OASIS-B .items');
                const box4Item: HTMLUListElement | null = document.querySelector('.OASIS-B .items .item');
                const scene1 = AniContainer.create({
                    asyncFromTo: [
                        [
                            box4Lists,
                            { x: (winW - Number(box4Item?.offsetWidth)) / 2 },
                            { x: winW / 2 - Number(box4Lists?.offsetWidth) + Number(box4Item?.offsetWidth) / 2 },
                            8,
                        ],

                        ['.OASIS-B .items .item-1 .item-text', { opacity: 1 }, { opacity: 1 }, 0.25],
                        ['.OASIS-B .items .item-1 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-B .items .item-1 .ef-img', { scale: 1.4 }, { scale: 1 }, 1],

                        ['.OASIS-B .items .item-2 .ef-img', { scale: 1 }, { scale: 1.4 }, 1.75],
                        ['.OASIS-B .items .item-2 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.OASIS-B .items .item-2 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-B .items .item-2 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.OASIS-B .items .item-3 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.OASIS-B .items .item-3 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.OASIS-B .items .item-3 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-B .items .item-3 .ef-img', { scale: 1.4 }, { scale: 1 }, 2],

                        ['.OASIS-B .items .item-4 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.OASIS-B .items .item-4 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.OASIS-B .items .item-4 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.OASIS-B .items .item-4 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.OASIS-B .items .item-5 .ef-img', { scale: 1 }, { scale: 1.4 }, 1],
                        ['.OASIS-B .items .item-5 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                    ],
                    asyncTimeLine: [
                        // 8份=> 1 : 2 : 2 : 2 : 1
                        0,
                        // 1份
                        0, 0.5, 0,
                        // 2份
                        0.5, 1.25, 2.5, 2.25,
                        // 2份
                        2, 3.5, 4.5, 4,
                        // 2份
                        4, 4.5, 6, 5.75,
                        // 1份
                        6.5, 6.75,
                    ],
                    triggerElement: '.OASIS-B .items',
                    triggerHook: 1,
                    duration: winH * 1.75 - 100,
                    offset: '100%',
                });
                // const scene2 = AniContainer.create({
                //     triggerElement: '.OASIS-B',
                //     triggerHook: 1,
                //     offset: '320%',
                //     duration: '200%',
                //     onEnter: () => setBtnEnter(true),
                //     onLeave: () => setBtnEnter(false),
                // });
                return () => {
                    scene1.destroy();
                    // scene2.destory();
                    textScene.destroy();
                };
            }
        }
    }, []);

    return (
        <section className={`${styles.section} OASIS-B`} id="dp3-K2">
            <div className="box">
                <div className={`info${textEnter ? ' enter' : ''}`}>
                    <div className="inner">
                        <p className="title s">{t(`K2_box4_title`)}</p>
                        <p className="desc s">
                            {t.rich(`K2_box4_desc`, {
                                w: (tx: string) => <span className="w">{tx}</span>,
                            })}
                        </p>
                    </div>
                </div>
                <div className="items-sticky">
                    <ul className={`items ${itemsEnter ? 'enter' : ''}`}>
                        {box4Items.map((item, k) => (
                            <li className={`item item-${k + 1}`} key={k}>
                                <div className={`item-inner item-inner-${k}`}>
                                    <div className="item-img">
                                        <EfImg pc={item.img} />
                                    </div>
                                    <p className="item-text">{item.text}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <p className="tip">{t('K2_box4_tip')}</p>
                </div>
                {/* <button className={`btn ${btnEnter ? 'enter' : ''}`} onClick={() => setIsOpen(true)}>
                    <span className="btn-text">{t('K2_box4_btn')}</span>
                    <EfImg className="btn-plus" pc="https://websiteoss.ecoflow.com/upload/image/1735629290398/add.svg" />
                </button> */}
            </div>
            {/* {isOpen && createPortal(<Modal2 type={isOpen} callback={() => setIsOpen(false)} />, document.body)} */}
        </section>
    );
}
